module.exports = __webpack_public_path__ + "static/img/ico_s_project@2x.e2a007b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ico_s_project@2x.png
// module id = A/Gm
// module chunks = 0